import React, {Component} from 'react';
import {connect} from 'react-redux';

import ItemPopupNotification from './notification/ItemPopupNotification';

import 'sass/popupNotifications.scss';

class PopupNotifications extends Component {

    render() {
        return false;

        return (
            <div className="popup-notifications">
                <ItemPopupNotification />
                <ItemPopupNotification />
            </div>
        )
    }
}

export default connect(
    state => ({
    }), 
    null
)(PopupNotifications);


// WEBPACK FOOTER //
// ./src/components/PopupNotifications.js